import React, { Component, Fragment } from "react";
import axios from "axios";
import FormInput from "../../components/FormInput";
import FormSelect from "../../components/FormSelect";

import { RESOURCE_TYPES } from "../../constants/constants";

export default class Resources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      type: "",
      media: null,
      isSubmitting: "",
      isLoading: false,
      resources: {},
      editingId: null,
      filter: ""
    };

    this.loadResources = this.loadResources.bind(this);
    this.initResourceState = this.initResourceState.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.mapResourcesTable = this.mapResourcesTable.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.setEditing = this.setEditing.bind(this);
    this.changeFilter = this.changeFilter.bind(this);
  }

  componentDidMount() {
    this.initResourceState();
    this.loadResources();
  }

  initResourceState() {
    this.setState({
      title: "",
      description: "",
      type: "",
      media: null,
      editingId: null
    });

    this.featuredImage1.value = null;
    this.featuredImage2.value = null;
    this.resourceFile.value = null;
  }

  loadResources() {
    this.setState({ isLoading: true }, async () => {
      await axios
        .get("/resources")
        .then(response => {
          this.setState({ isLoading: true, resources: response.data });
        })
        .catch(err => {
          console.log("Error Loading Resources: ", err);
          this.setState({ isLoading: false });
        });
    });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ isSubmitting: true }, async () => {
      const data = new FormData();
      const { resources } = this.state;

      if (this.state.title === "" || this.state.type === "") {
        alert("Invalid Empty Fields");
        return null;
      }

      data.append("title", this.state.title);
      data.append("type", this.state.type);
      data.append("description", this.state.description);
      data.append("featuredImage1", this.featuredImage1.files[0]);
      data.append("featuredImage2", this.featuredImage2.files[0]);
      data.append("resourceFile", this.resourceFile.files[0]);

      if (this.state.editingId === null) {
        // adding new
        await axios
          .post("/resources", data)
          .then(response => {
            resources.unshift(response.data);
            this.setState({ resources, isSubmitting: false });
            this.initResourceState();
          })
          .catch(err => {
            console.log("failed to submit data: ", err);
            this.setState({ isSubmitting: false });
          });
      } else {
        // is editing
        data.append("id", this.state.editingId);
        await axios
          .put("/resources", data)
          .then(response => {
            for (let x in resources) {
              if (resources[x]["id"] === response.data.id) {
                resources[x] = response.data;
                break;
              }
            }
            this.setState({ resources, isSubmitting: false });
            this.initResourceState();
          })
          .catch(err => {
            console.log("failed to submit data: ", err);
            this.setState({ isSubmitting: false });
          });
      }
    });
  }

  async confirmDelete(id) {
    // eslint-disable-next-line no-restricted-globals
    const action = confirm("Confirm Deletion?");
    if (action) {
      await axios
        .delete(`/resources/${id}`)
        .then(response => {
          console.log("response after delete", response);
        })
        .catch(err => {
          console.log("failed to delete resource");
        });
    } else {
      alert("don't delete");
    }
  }

  setEditing(id) {
    const { resources } = this.state;
    const resourceSelected = resources
      .filter(resource => resource.id === id)
      .shift();

    console.log("selecetd Resource is: ", resourceSelected);
    if (resourceSelected !== undefined) {
      this.setState({
        editingId: id,
        title: resourceSelected.title,
        type: resourceSelected.type,
        description: resourceSelected.description,
        media: {
          featuredImage1: resourceSelected.featured_image,
          featuredImage2: resourceSelected.featured_image2,
          resourceFile: resourceSelected.file
        }
      });
    }
  }

  mapResourcesTable() {
    const { resources, filter } = this.state;
    let response = [];
    if (resources.length !== undefined && resources.length !== 0) {
      for (let resource in resources) {
        const resourceInfo = resources[resource];
        const resourceType = RESOURCE_TYPES.filter(
          type => type.id === parseInt(resourceInfo.type, 10)
        ).shift();
        // filtering according to selected type
        if (filter !== "" && resourceInfo.type !== Number(filter)) {
          continue;
        }

        response.push(
          <tr key={resourceInfo.id}>
            <td>{resourceInfo.id}</td>
            <td>{resourceInfo.title}</td>
            <td>{resourceType.name}</td>
            <td>
              {resourceType.id < 3 && (
                <img
                  src={`${axios.defaults.baseURL}/uploads/${
                    resourceInfo.featured_image
                  }`}
                  alt={resourceInfo.title}
                  style={{ maxHeight: 80 }}
                />
              )}
            </td>
            <td>
              <button
                className="btn btn-info"
                onClick={() => {
                  this.setEditing(resourceInfo.id);
                }}
              >
                <i className="fa fa-edit" />
              </button>
              <button
                className="btn btn-danger"
                onClick={() => {
                  this.confirmDelete(resourceInfo.id);
                }}
              >
                <i className="fa fa-trash" />
              </button>
            </td>
          </tr>
        );
      }
      return response;
    } else {
      return null;
    }
  }

  changeFilter(e) {
    this.setState({ filter: e.target.value });
  }

  render() {
    const { editingId, media, filter } = this.state;

    return (
      <div className="content-admin resources row">
        <div className="add-resoruce">
          <h2 className="col-sm-12">
            {editingId !== null
              ? `Edit Resource (#${editingId})`
              : "Add Resource"}
          </h2>
          <form
            onSubmit={this.handleFormSubmit}
            encType="multipart/form-data"
            method="post"
          >
            {FormInput(this, "Title", "title", "text", null, null, "col-sm-6")}
            {FormSelect(this, "Type", "type", RESOURCE_TYPES, "col-sm-6")}
            <div className="col-sm-12">
              <textarea
                className="form-control"
                placeholder="Description for the resource"
                onChange={e => {
                  this.setState({ description: e.target.value });
                }}
                value={this.state.description}
                style={{ height: 80, marginBottom: 20 }}
              />
            </div>
            <div className="col-sm-6">
              <div className="row">
                <div className="col-sm-12 form-group">
                  <label>Main Featured Image</label>
                  <input
                    className="fomrm-control"
                    ref={ref => {
                      this.featuredImage1 = ref;
                    }}
                    type="file"
                  />
                  {media !== null && media.featuredImage1 !== null && (
                    <Fragment>
                      <small style={{ display: "block" }}>
                        Uploading new file will replace exising media
                      </small>
                      <img
                        src={`${axios.defaults.baseURL}/uploads/${
                          media.featuredImage1
                        }`}
                        alt="featuredImage1"
                        style={{ maxHeight: 80 }}
                      />
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="row">
                <div className="col-sm-12 form-group">
                  <label>Post Featured Image</label>
                  <input
                    className="form-control"
                    ref={ref => {
                      this.featuredImage2 = ref;
                    }}
                    type="file"
                  />
                  {media !== null && media.featuredImage2 !== null && (
                    <Fragment>
                      <small style={{ display: "block" }}>
                        Uploading new file will replace exising media
                      </small>
                      <img
                        src={`${axios.defaults.baseURL}/uploads/${
                          media.featuredImage2
                        }`}
                        alt="featuredImage2"
                        style={{ maxHeight: 80 }}
                      />
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className="break" />
            <div className="col-sm-6">
              <div className="row">
                <div className="col-sm-12 form-group">
                  <label>Main Resource File</label>
                  <input
                    className="fomrm-control"
                    ref={ref => {
                      this.resourceFile = ref;
                    }}
                    type="file"
                  />
                  {media !== null && media.resourceFile !== null && (
                    <Fragment>
                      <small style={{ display: "block" }}>
                        Uploading new file will replace exising media
                      </small>

                      <p>
                        Previous file is:{" "}
                        <a
                          href={`${axios.defaults.baseURL}/uploads/${
                            media.resourceFile
                          }`}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {media.resourceFile}
                        </a>
                      </p>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <button
                className="btn btn-success btn-lg"
                style={{ marginTop: 30 }}
                type="submit"
              >
                Save
              </button>
              <button
                className="btn btn-outline btn-lg"
                style={{ marginTop: 30 }}
                type="button"
                onClick={this.initResourceState}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-12">
          <hr />
        </div>
        <h2 className="col-sm-12">List Resources</h2>
        <div className=" list-resources col-sm-12">
          <div className="table table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th style={{ width: "40%" }}>Name</th>
                  <th>
                    <select value={filter} onChange={this.changeFilter}>
                      <option value="">Type</option>
                      {RESOURCE_TYPES.map(type => (
                        <option key={`filter-${type.id}`} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th>Featured Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{this.mapResourcesTable()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
